import { RedirectUrlParams } from 'src/app/interfaces/query-url-params.interface';
import { CommunityInviteOrDeclineRequest, ProjectInviteOrDeclineRequest } from 'src/app/swagger-api';
import { isSatisfyUnion } from 'src/app/utils';

export type ProjectInvitation = 'project_accept' | 'project_reject' | 'project_accept_join_request';
export type CommunityInvitation = 'community_accept' | 'community_reject' | 'community_accept_join_request';

export type RedirectAction = ProjectInvitation | CommunityInvitation;

export const INVITATION_STATUSES_MAPPER: {
  [key in RedirectAction]: CommunityInviteOrDeclineRequest.InvitationStatusEnum;
} = {
  community_accept_join_request: CommunityInviteOrDeclineRequest.InvitationStatusEnum.Approved,
  community_accept: CommunityInviteOrDeclineRequest.InvitationStatusEnum.Approved,
  community_reject: CommunityInviteOrDeclineRequest.InvitationStatusEnum.Rejected,
  project_accept: ProjectInviteOrDeclineRequest.InvitationStatusEnum.Approved,
  project_reject: ProjectInviteOrDeclineRequest.InvitationStatusEnum.Rejected,
  project_accept_join_request: ProjectInviteOrDeclineRequest.InvitationStatusEnum.Approved,
};

export const isRedirectUrlParams = (params: RedirectUrlParams | unknown): params is RedirectUrlParams => {
  if (params !== undefined && params !== null && typeof params == 'object') {
    return (
      'url' in params &&
      'actorId' in params &&
      'entityId' in params &&
      'serverAction' in params &&
      isSatisfyUnion<RedirectAction>(params.serverAction as string, [
        'project_accept',
        'project_reject',
        'project_accept_join_request',
        'community_accept',
        'community_reject',
        'community_accept_join_request',
      ])
    );
  }

  return false;
};
